import Swiper from 'swiper/bundle';

const breakPoint = 700;
let swiper, swiperBool;

window.addEventListener(
  "load",
  () => {
    createSwiper();

    if (breakPoint >= window.innerWidth) {
      createSwiperOnlySp();
      swiperBool = true;
    } else {
      swiperBool = false;
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    if (breakPoint >= window.innerWidth && !swiperBool) {
      createSwiperOnlySp();
      swiperBool = true;
    } else if (breakPoint < window.innerWidth && swiperBool) {
      swiper.destroy(false, true);
      swiperBool = false;
    }
  },
  false
);

const createSwiperOnlySp = () => {
  swiper = new Swiper('.js-photoSliderSp', {
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 3000,
    },
    speed: 1000,
    loop: true,
  });
};

const createSwiper = () => {
  new Swiper('.js-photoSlider', {
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 3000,
    },
    speed: 1000,
    loop: true,
  });

  new Swiper('.js-noCtrlSlider', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 3000,
    },
    speed: 1000,
    loop: true,
  });
};

